import { planReducer } from "./planReducer";
import { combineReducers } from "redux";
import { productReducer } from "./productReducer";

export const rootReducer = combineReducers({
  plan: planReducer,
  product: productReducer,
});
